import { isProline } from '../../../../helpers'
import ProLineFooter from './ProLineFooter'
import SpiritFooter from './SpiritFooter'

const Footer: React.FC = () => {
  return <div>{isProline() ? <ProLineFooter /> : <SpiritFooter />}</div>
}

export default Footer
